<template>
  <el-table-column
    prop="nick_name"
    label="Becenév"
    sortable="custom"
    min-width="150"
    show-overflow-tooltip
  >
    <template slot-scope="scope">
      {{ scope.row.nick_name || '-' }}
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'nick_name',
  };
</script>
